import domReady from '@wordpress/dom-ready';
import { debounce } from '../util';

domReady( () => {
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

  /* Block scripts */
  if ( document.querySelector('.statistic') ) {
    document.querySelectorAll('.statistic').forEach(block => {
      const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
      if ( motionQuery && motionQuery.matches ) {
        return;
      }
      const numEl = block.querySelector('.statistic-figure__main');
      const labelEl = block.querySelector('.statistic-figure__label');
      const prefix = numEl.dataset.prefix || '';
      const suffix = numEl.dataset.suffix || '';
      const num = numEl.dataset.num;

      const numAnimator = {
        number: 0
      };

      let windowWidth = window.innerWidth;

      numEl.style.flex = '0 0 ' + (numEl.offsetWidth + 16) + 'px';
      window.addEventListener('resize', debounce(function() {
        numEl.style.flex = '0 0 auto';
        numEl.style.flex = '0 0 ' + (numEl.offsetWidth + 16) + 'px';
        windowWidth = window.innerWidth;
      }));

      const numSplit = SplitText.create(numEl, {
        type: 'lines',
        linesClass: 'split-line',
        mask: 'lines',
        autoSplit: false,
        onSplit: function(self) {
          gsap.set(self.lines, {
            y: '100%',
            opacity: 0
          });

          gsap.to(self.lines, {
            y: '0%',
            opacity: 1,
            duration: 0.85,
            ease: 'expo.inOut',
            stagger: 0.08,
            scrollTrigger: {
              trigger: block,
              start: 'top bottom',
              end: 'bottom top',
              toggleActions: 'play none none reverse',
              onEnter: function() {
                gsap.to(numAnimator, {
                  number: num,
                  duration: 1.2,
                  ease: num < 10 ? 'power2.out' : 'expo.inOut',
                  overwrite: true,
                  onUpdate: function() {
                    if ( numAnimator.number < 10 ) {
                      if ( numAnimator.number % 1 !== 0 ) {
                        self.lines[0].textContent = prefix + numAnimator.number.toFixed(windowWidth < 767 ? 1 : 2).toLocaleString() + suffix;
                      } else {
                        self.lines[0].textContent = prefix + Math.round(numAnimator.number).toLocaleString() + suffix;
                      }
                    } else {
                      self.lines[0].textContent = prefix + Math.round(numAnimator.number).toLocaleString() + suffix;
                    }
                  }
                });
              },
              onLeaveBack: function() {
                gsap.set(numAnimator, {
                  number: 0
                });
                numSplit.lines[0].textContent = prefix + '0' + suffix;
              }
            }
          })
        }
      });

      const labelSplit = SplitText.create(labelEl, {
        type: 'lines',
        linesClass: 'split-line',
        mask: 'lines',
        autoSplit: false,
        onSplit: function(self) {
          gsap.set(self.lines, {
            y: '100%',
            opacity: 0
          });

          gsap.to(self.lines, {
            y: '0%',
            opacity: 1,
            duration: 0.85,
            ease: 'expo.inOut',
            stagger: 0.08,
            scrollTrigger: {
              trigger: block,
              start: 'top bottom',
              end: 'bottom top',
              toggleActions: 'play none none reverse'
            }
          })
        }
      });

      window.addEventListener('resize', debounce(function() {
        labelSplit.revert();
        labelSplit.split();
      }));
    });
  }
});